import { useState } from 'react';
import InternalTooltip from './Tooltip';
import InternalTag from './Tag';
import TruncateText from './TruncateText';
import { BiCloset } from 'react-icons/bi';
import InternalStatusLabel from './StatusLabel';

const Tooltip = ({content, sizeRequest}) =>
  <InternalTooltip sizeRequest={sizeRequest}>
    {typeof content === 'string' ? <p>{content}</p> : content}
  </InternalTooltip>;


export const WithTooltip = ({content, children, sizeRequest}) =>
{
  const [isTooltipVisible, setIsTooltipVisible] = useState(false);
  return (
    <div className='ui-with-tooltip relative inline-block' onMouseOver={() => setIsTooltipVisible(true)} onMouseOut={() => setIsTooltipVisible(false)}>
      {children}
      {isTooltipVisible ? <Tooltip content={content} sizeRequest={sizeRequest} /> : <></>}
    </div>
  );
}

export const Tag = ({onClose, title, maxChars}) =>
  <InternalTag closeIcon={<BiCloset />} onClose={onClose}>
    <p><TruncateText maxChars={maxChars}>{title}</TruncateText></p>
  </InternalTag>;


export const DefaultStatusLabel = ({title}) =>
  <InternalStatusLabel type='default'>
    <p>{title}</p>
  </InternalStatusLabel>;
export const ProgressStatusLabel = ({title}) =>
  <InternalStatusLabel type='progress'>
    <p>{title}</p>
  </InternalStatusLabel>;
export const PositiveStatusLabel = ({title}) =>
  <InternalStatusLabel type='positive'>
    <p>{title}</p>
  </InternalStatusLabel>;
export const WarningStatusLabel = ({title}) =>
  <InternalStatusLabel type='warning'>
    <p>{title}</p>
  </InternalStatusLabel>;
export const NegativeStatusLabel = ({title}) =>
  <InternalStatusLabel type='negative'>
    <p>{title}</p>
  </InternalStatusLabel>;
export const OrangeStatusLabel = ({title}) =>
  <InternalStatusLabel type='orange'>
    <p>{title}</p>
  </InternalStatusLabel>;
export const DarkRedStatusLabel = ({title}) =>
  <InternalStatusLabel type='dark-red'>
    <p>{title}</p>
  </InternalStatusLabel>;
